// Store banner check functions for resize handler
const bannerCheckFunctions = new Map();

const setupBannerAlignment = (banner, bannerId) => {
  if (!banner) return;

  const textElement = banner.querySelector('.banner__text--dismissable');
  const textWrapper = banner.querySelector('.banner__text__wrapper');
  const dismissableWrapper = banner.querySelector('.banner__wrapper--dismissable');

  if (!textElement || !textWrapper || !dismissableWrapper) return;

  // Check if text wraps to multiple lines
  const checkTextWrap = () => {
    // Get computed styles to determine line height
    const computedStyle = window.getComputedStyle(textElement);
    const lineHeight = parseFloat(computedStyle.lineHeight);

    // If lineHeight is 'normal', estimate it as 1.2x font size
    const actualLineHeight = isNaN(lineHeight) || lineHeight === 0
      ? parseFloat(computedStyle.fontSize) * 1.2
      : lineHeight;

    // Account for padding (top + bottom) when comparing heights
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
    const totalPadding = paddingTop + paddingBottom;

    // Compare element's content height to line height
    // If content height is greater than line height, text is wrapping
    const elementHeight = textElement.offsetHeight;
    const contentHeight = elementHeight - totalPadding;
    const isWrapping = contentHeight > actualLineHeight * 1.1; // 1.1 tolerance for rounding

    if (isWrapping) {
      // Text wraps - align items to top
      textWrapper.classList.remove('banner__text__wrapper--centered');
      textWrapper.classList.add('banner__text__wrapper--top');
      dismissableWrapper.classList.remove('banner__wrapper--dismissable--centered');
      dismissableWrapper.classList.add('banner__wrapper--dismissable--top');
    } else {
      // Single line - center items
      textWrapper.classList.remove('banner__text__wrapper--top');
      textWrapper.classList.add('banner__text__wrapper--centered');
      dismissableWrapper.classList.remove('banner__wrapper--dismissable--top');
      dismissableWrapper.classList.add('banner__wrapper--dismissable--centered');
    }
  };

  // Store check function for resize handler
  bannerCheckFunctions.set(bannerId, checkTextWrap);

  // Use requestAnimationFrame to ensure layout is complete
  requestAnimationFrame(() => {
    checkTextWrap();
  });
};

// Single debounced resize handler for all banners
let resizeTimeout;
const handleResize = () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    bannerCheckFunctions.forEach(checkFn => checkFn());
  }, 100);
};

window.addEventListener('DOMContentLoaded', () => {
  // Find all dismissable alert banners
  const dismissableBanners = document.querySelectorAll('[data-banner-type="dismissable"]');

  dismissableBanners.forEach(banner => {
    const bannerId = banner.getAttribute('data-banner');
    setupBannerAlignment(banner, bannerId);
  });

  // Add single resize listener for all banners
  window.addEventListener('resize', handleResize);
});